<img [src]="getSafeSrc()" class="preview-object">